import { LottieType } from "@cart-client/components/common-header/components/helper";
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";
import { Lottie } from "@swiggy-private/cart-types";

import { TOING_RTB_HEADER_LOTTIE_FINAL_STATE_FRAMES, TOING_RTB_HEADER_LOTTIE_FRAMES } from "./constants";

export const getToingRtbHeaderLottieArray = (cartResponse: ReviewedCart | null): Lottie[] => {
    const apiLotties = cartResponse?.data?.cart_header_widget_presentation?.header_lottie_config?.lotties || [];
    const mainLottie = apiLotties.find((lottie) => lottie.type === LottieType.MAIN);
    if (mainLottie && !isEmpty(mainLottie.lottie_id)) {
        return [mainLottie];
    }
    return [];
};

export const getToingRtbRxAndSessionIds = (cartResponse: ReviewedCart | null): { rxId: string; sid: string } => {
    const restaurantId = cartResponse?.data?.restaurant_details?.id;
    const rxId = isEmpty(restaurantId) ? "" : String(restaurantId);
    const sid = GlobalHeaderState.getHeader(SwgyHeaderKeysList.sid) || "";
    return { rxId, sid };
};

export const getToingRtbHeaderLottieFrame = (showFinalState: boolean): { initial: number; final: number } =>
    showFinalState ? TOING_RTB_HEADER_LOTTIE_FINAL_STATE_FRAMES : TOING_RTB_HEADER_LOTTIE_FRAMES;
